const theme = {
  colors: {
    // primary: '#F7B32B',
    primary: '#1385d1',
    // secondary: '#095263',
    secondary: '#1f508f',
    background: {
      // primary: "#0F1A3D",
      // secondary: '#1d2754',
      primary: '#14243f',
      secondary: '#0e1d35',
    },
    success: '#00C853',
    border: '#415075',
    danger: '#BA2020',
    points: '#F7B32B',
    text: {
      title: '#E4E4E6',
      subtitle: '#E4E4E6',
      body: '#FFFFFFCC',
      default: '#FFFFFF',
      contrast: '#0F1A3D',
      caption: '#FFFFFF80',
    },
    skeleton: '#09172f',
  },
  appWidth: 900,
};

export default theme;
